// test702
(702 && 0);
